import React from 'react';
import { ServiceContextProvider } from '../components/TimeAndExpenseServiceContext';
import TimeAndExpensePageComponent from './TimeAndExpensePageComponent';
const TimeAndExpensePage = () => {
  return (
    <ServiceContextProvider>
      <TimeAndExpensePageComponent />
    </ServiceContextProvider>
  );
};
export default TimeAndExpensePage;



// WEBPACK FOOTER //
// ./src/components/project-billing/pages/TimeAndExpensePage.tsx